import script from "./LeaderProjectStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectStudents.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectStudents.vue?vue&type=style&index=0&id=7b436e01&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b436e01"]])

export default __exports__